import React, { useContext } from 'react';

import { DropzoneInputContext } from './dropzone-input.context';

// TODO: fix typings
export type DropzoneInputProps = any;
// React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export const DropzoneInput = (props: DropzoneInputProps) => {
  const dropzoneProps = useContext(DropzoneInputContext);
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <input {...dropzoneProps} {...props} />;
};
